<template>
  <b-col cols="12">
    <input class="form-control" v-model="date" placeholder="MM/dd/yyyy" />
    <small>Enter {{ type }} - Month / Day / Year</small>
  </b-col>
</template>

<script>
export default {
  name: "Date",
  props: ["type", "DOBPresent"],
  data() {
    return {
      date: "",
    };
  },
  mounted() {
    if (this.DOBPresent) {
      const DOB = this.$route.query.dob;
      const dateSplit = DOB.split("-");
      // basic test for DOB to have correct format
      if (dateSplit.length === 3) {
        // Month
        this.date = dateSplit[1];
        // Date
        this.date += ` / ${dateSplit[2]}`
        // Year
        this.date += ` / ${dateSplit[0]}`
      }
    }
  },
  methods: {
    convertDate(d) {
      var date = d.split("/");
      return date[2].trim() + "-" + date[0].trim() + "-" + date[1].trim();
    },
    checkDate(str, max) {
      if (str.charAt(0) !== "0" || str == "00") {
        var num = parseInt(str);
        if (isNaN(num) || num <= 0 || num > max) num = 1;
        str =
          num > parseInt(max.toString().charAt(0)) && num.toString().length == 1
            ? "0" + num
            : num.toString();
      }
      return str;
    },
    checkYear(str, min, max) {
      if (parseInt(str.charAt(0)) >= 1 && parseInt(str.charAt(0)) < 3) {
        var num = parseInt(str);
        if (isNaN(num) || (str.length === 2 && (num > 20 || num < 19)))
          return 1;
        if (str.length === 4) {
          if (
            num > parseInt(min.toString()) &&
            num < parseInt(max.toString())
          ) {
            return num.toString();
          } else {
            return "";
          }
        }
      } else {
        return "";
      }
      return str;
    },
  },
  watch: {
    date: function () {
      var input = this.date;
      if (/\D\/$/.test(input)) input = input.substr(0, input.length - 3);
      var values = input.split("/").map(function (v) {
        return v.replace(/\D/g, "");
      });
      if (values[0]) values[0] = this.checkDate(values[0], 12);
      if (values[1]) values[1] = this.checkDate(values[1], 31);
      if (values[2])
        values[2] = this.checkYear(values[2], 1900, new Date().getFullYear());
      var output = values.map(function (v, i) {
        return v.length == 2 && i < 2 ? v + " / " : v;
      });
      this.value = output.join("").substr(0, 14);
      this.date = this.value;
      var acceptedDate;
      if (this.value.length === 14) {
        acceptedDate = this.convertDate(this.value);
      }
      this.$emit("custom-date", acceptedDate);
    },
  },
};
</script>

<style>
</style>